import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useCRMAuth } from '../../context/CRMAuthContext';

const NAV_ITEMS_ADMIN = [
  { to: '/crm/dashboard', label: 'Бошқарув панели' },
  { to: '/crm/requests', label: 'Сўровлар' },
  { to: '/crm/articles', label: 'Мақолалар' },
  { to: '/crm/rating-submissions', label: 'Рейтинг' },
  { to: '/crm/staff', label: 'Ходимлар' },
];
const NAV_ITEMS_STAFF = [
  { to: '/crm/requests', label: 'Сўровлар' },
];

const CRMLayout = ({ children }) => {
  const { crmUser, crmLogout } = useCRMAuth();
  const navItems = crmUser?.role === 'admin' ? NAV_ITEMS_ADMIN : NAV_ITEMS_STAFF;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f7fafc' }}>
      {/* Sidebar */}
      <div style={{
        width: '220px', flexShrink: 0, backgroundColor: '#1a365d',
        display: 'flex', flexDirection: 'column',
      }}>
        <div style={{ padding: '1.5rem 1.25rem', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ color: 'white', fontWeight: '800', fontSize: '1.1rem' }}>AdvokatTop</div>
          <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.75rem', marginTop: '0.2rem' }}>CRM</div>
        </div>
        <nav style={{ flex: 1, padding: '1rem 0' }}>
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              style={({ isActive }) => ({
                display: 'block', padding: '0.7rem 1.25rem',
                color: isActive ? 'white' : 'rgba(255,255,255,0.65)',
                backgroundColor: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                textDecoration: 'none', fontSize: '0.9rem', fontWeight: isActive ? '600' : '400',
                borderLeft: isActive ? '3px solid #63b3ed' : '3px solid transparent',
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '1rem 1.25rem', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
            {crmUser?.name}
            <span style={{ marginLeft: '0.4rem', fontSize: '0.7rem', backgroundColor: 'rgba(255,255,255,0.15)', padding: '0.1rem 0.4rem', borderRadius: '10px', color: 'rgba(255,255,255,0.7)' }}>
              {crmUser?.role === 'admin' ? 'Админ' : 'Ходим'}
            </span>
          </div>
          <button
            onClick={crmLogout}
            style={{
              background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)',
              padding: '0.35rem 0.75rem', borderRadius: '6px', fontSize: '0.8rem', cursor: 'pointer', width: '100%',
            }}
          >
            Чиқиш
          </button>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
};

export default CRMLayout;
